import React, {useState} from 'react'
import A from './A'

const Menu = ({ items = [], parent = 0, className }) => {
  const [refreshDummy, setRefreshDummy] = useState(0);
  const levelItems = items.filter(item => item.getParent() === parent);
  if (levelItems.length === 0) return null;
  const handleClick = e => {
    setRefreshDummy(refreshDummy + 1);
  };
  return (
    <ul className={!parent?className:undefined}>
      {levelItems.map((item, key) => (item.getParent() === parent ?
        <li key={key}>
          <A href={item.getUrl()} onClick={handleClick}>{item.getTitle()}</A>
          <Menu items={items} parent={item.getId()} />
        </li>
      :
        null
      ))}
    </ul>
  )
}

export default Menu


// WEBPACK FOOTER //
// ./src/components/Menu.js